import { Component, Inject, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { MasterService } from "../../../../serivces/master.service";

import { SVG_ICONS } from "../../../../models/icons";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedModule } from "@frontend/app/shared/shared.module";

@Component({
  selector: "app-plan-details",
  imports: [CommonModule, SharedModule],
  templateUrl: "./plan-details.component.html",
  styleUrl: "./plan-details.component.scss",
})
export class PlanDetailsComponent implements OnInit {
  private masterService = inject(MasterService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<PlanDetailsComponent>) {}
  ngOnInit() {
    if (this.data.packageData) {
      this.packageDetails = this.data.packageData;

      // this.getPackageDetails();
    }
  }

  //#region variables
  PackageID: any;
  packageDetails: any;
  readonly SVG_ICONS = SVG_ICONS;
  //#endregion

  getPackageDetails() {
    this.masterService.getPackageDetailsByID(this.PackageID).subscribe((res: any) => {
      console.log(res);

      this.packageDetails = res.data;
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
